<template>
  <div class="page flex-col">
    <div class="back">
      <BackButton />
    </div>

    <div class="container">
      <div class="student_profile_card flex-col">
        <div class="profile_title_wrapper flex-row">
          <span class="profile_title">学生资料</span>
        </div>
        <div class="title_divider flex-row">
          <div class="divider_line flex-col"></div>
        </div>

        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">ID</span>
          <span class="info_value">{{ info.id }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">学年</span>
          <span class="info_value">{{ info.academicYear }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">班级(ID)</span>
          <span class="info_value">{{ info.classNo }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">班级(名称)</span>
          <span class="info_value">{{ info.className }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">学号</span>
          <span class="info_value">{{ info.studentNo }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">用户名</span>
          <span class="info_value">{{ info.userName }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">姓名</span>
          <span class="info_value">{{ info.studentName }}</span>
        </div>
        <div class="profile_info_row flex-row justify-between">
          <span class="info_label">性别</span>
          <span class="info_value">{{ info.gender }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useStore } from "vuex"

import BackButton from "@/components/teacher/BackButton.vue"

const info = ref({
  id: 1,
  academicYear: "2024-2025",
  classNo: "1",
  className: "test",
  studentNo: "test001",
  userName: "testName",
  studentName: "stu001",
  gender: "男",
})
const store = useStore()

onMounted(() => {
  if (store.getters.getCurrentStudent) {
    info.value = store.getters.getCurrentStudent
  }
})
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.back {
  margin: 0.6vw 0 0 1.25vw;
}

.container {
  position: relative;
  width: 80.68vw;
  height: 20vw;
  margin-left: 1.25vw;
  margin-top: 0.6vw;
}

.student_profile_card {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  height: 30vw;
  width: 30.68vw;
  justify-content: flex-center;
  margin-top: 0.2vw;
}

.profile_title_wrapper {
  width: 4.59vw;
  height: 1.52vw;
  margin: 2.91vw 0 0 2.65vw;
}

.profile_title {
  width: 4.59vw;
  height: 1.52vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.14vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.15vw;
}

.title_divider {
  width: 7.45vw;
  height: 0.11vw;
  margin: 0.62vw 0 0 2.65vw;
}

.divider_line {
  background-color: rgba(104, 162, 250, 0.6);
  width: 7.45vw;
  height: 0.11vw;
}

.profile_info_row:last-of-type {
  margin-bottom: 2.91vw;
}

.profile_info_row {
  width: 25.99vw;
  height: 1.25vw;
  margin: 1.25vw 0 0 2.65vw;
}

.info_label {
  width: 6.78vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
}

.info_value {
  width: 17.61vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
}
</style>
